import { convertToNumber, isNaN2 } from "./DataHelpers";

export function numberToComma(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function formatNumber(x: number): string {
  if (isNaN2(x)) {
    return "-";
  }
  let decimals = 1;
  const absVal = Math.abs(x);
  if (absVal < 10) {
    decimals = 100;
  } else if (absVal < 1000) {
    decimals = 10;
  }
  x = Math.round(x * decimals) / decimals;
  let formatted = numberToComma(x);

  if (formatted.includes(".") && formatted.endsWith("0")) {
    formatted = formatted.substring(0, formatted.length - 1);
  }
  if (formatted.includes(".") && formatted.endsWith("0")) {
    formatted = formatted.substring(0, formatted.length - 1);
  }
  if (formatted.endsWith(".")) {
    formatted = formatted.substring(0, formatted.length - 1);
  }
  return formatted;
}

export function toPercent(val: string) {
  let valNum = convertToNumber(val) * 100;
  return formatNumber(valNum) + "%";
}
